var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "sub-nav" },
      [
        _c(
          "li",
          {
            staticClass: "d-none",
            on: {
              click: function($event) {
                return _vm.handleTab("services")
              }
            }
          },
          [
            _c("i", { staticClass: "fas fa-pen-nib fa-fw" }),
            _vm._v(" PROFESSIONAL SERVICES\n\t\t\t"),
            _c("span", { staticClass: "sub-nav-value" }, [
              _vm._v("\n\t\t\t\tNeed professional help?\n\t\t\t")
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons md-18 arrow-more" }, [
              _vm._v("keyboard_arrow_right")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            on: {
              click: function($event) {
                return _vm.handleTab("exports")
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons md-18" }, [
              _vm._v("cloud_download")
            ]),
            _vm._v(" DOWNLOADS (4)\n\t\t\t"),
            _c("span", { staticClass: "sub-nav-value" }, [
              _vm._v("\n\t\t\t\tClient Ready PDF\n\t\t\t")
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons md-18 arrow-more" }, [
              _vm._v("keyboard_arrow_right")
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              inactive: !_vm.parcel.zoning || _vm.parcel.zoning.length < 1
            },
            on: {
              click: function($event) {
                return _vm.handleTab("zoning")
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons md-18" }, [
              _vm._v("assignment")
            ]),
            _vm._v(
              " ZONING (" + _vm._s(_vm.parcel.zoning.length) + ")\n\t\t\t"
            ),
            _vm.parcel.zoning && _vm.parcel.zoning.length > 0
              ? _c("span", { staticClass: "sub-nav-value" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.subNavShorten(_vm.parcel.zoning[0].designation)
                      ) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons md-18 arrow-more" }, [
              _vm._v("keyboard_arrow_right")
            ])
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.overlayCategories, function(category, index) {
          return _c(
            "li",
            {
              on: {
                click: function($event) {
                  return _vm.handleTab(index)
                }
              }
            },
            [
              _c("i", { staticClass: "material-icons md-18" }, [
                _vm._v(_vm._s(_vm.getCategoryIcon(index)))
              ]),
              _vm._v(
                " " +
                  _vm._s(index.toUpperCase()) +
                  " (" +
                  _vm._s(category.length) +
                  ")\n\t\t\t"
              ),
              _c("span", { staticClass: "sub-nav-value" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(_vm.subNavShorten(category[0].name)) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons md-18 arrow-more" }, [
                _vm._v("keyboard_arrow_right")
              ])
            ]
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              inactive: !_vm.parcel.permits || _vm.parcel.permits.length < 1
            },
            on: {
              click: function($event) {
                return _vm.handleTab("permits")
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons md-18" }, [
              _vm._v("business_center")
            ]),
            _vm._v(
              " PERMITS (" + _vm._s(_vm.parcel.permits.length) + ")\n\t\t\t"
            ),
            _vm.parcel.permits && _vm.parcel.permits.length > 0
              ? _c("span", { staticClass: "sub-nav-value" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.subNavShorten(_vm.parcel.permits[0].typeRaw)) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("i", { staticClass: "material-icons md-18 arrow-more" }, [
              _vm._v("keyboard_arrow_right")
            ])
          ]
        )
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tSTATS \n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("APN")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.apnFmt !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.parcel.apnFmt) + "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Lot size")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.geomArea !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.lotSizeAcres) +
                    " acres \n\t\t\t\t\t"
                ),
                _c("span", { staticClass: "text-muted font-weight-light" }, [
                  _vm._v("|")
                ]),
                _vm._v(
                  " \n\t\t\t\t\t" + _vm._s(_vm.lotSizeFt) + " SF\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.parcel.owner !== null
      ? _c("div", { staticClass: "category" }, [
          _c("div", { staticClass: "category-title" }, [
            _vm._v("\n\t\t\tOWNER \n\t\t")
          ]),
          _vm._v(" "),
          _vm.parcel.unlocked === false
            ? _c(
                "div",
                {
                  staticClass: "lock-block mt-2 mb-2",
                  on: { click: _vm.unlock }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "lock-text" }, [
                    _c("h5", { staticClass: "mb-0 text-white" }, [
                      _vm._v("Unlock to view owner's information")
                    ]),
                    _vm._v(" "),
                    _c(
                      "h5",
                      { staticClass: "mb-0 font-weight-light text-light" },
                      [
                        _vm._v(
                          "$" +
                            _vm._s(_vm.plans.parcelUnlock.price) +
                            " to unlock all info for this parcel"
                        )
                      ]
                    )
                  ])
                ]
              )
            : _c("div", { staticClass: "property-row" }, [
                _c("label", [_vm._v("Contact")]),
                _vm._v(" "),
                _c("div", { staticClass: "property-value-right text-right" }, [
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.name1))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.name2))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.name3))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.address1))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.address2))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.address3))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.address4))]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.parcel.owner.postal))])
                ])
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tCOMMUNITY PLAN\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Name")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.communityPlan !== null &&
          _vm.parcel.communityPlan.name !== null
            ? _c(
                "span",
                {
                  staticClass: "link",
                  on: {
                    click: function($event) {
                      return _vm.routeCommunityPlan(_vm.parcel.communityPlan)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.parcel.communityPlan.name) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tASSESSOR\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Land")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.assessor.land !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm._f("currency")(_vm.parcel.assessor.land)) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Improvements")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.assessor.improvements !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("currency")(_vm.parcel.assessor.improvements)
                    ) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tSTRUCTURE\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Effective year built")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.effectiveYearBuilt !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.structure.effectiveYearBuilt) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Living SF")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.livingSF !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("numberWithCommas")(_vm.parcel.structure.livingSF)
                    ) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Usable SF")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.usableSF !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(
                      _vm._f("numberWithCommas")(_vm.parcel.structure.usableSF)
                    ) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Units")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.units !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.structure.units) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Bedrooms")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.bedrooms !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.structure.bedrooms) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Bathrooms")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.structure.bathrooms !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.structure.bathrooms) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tSUBDIVISION\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Name")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.subdivision.name !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.subdivision.name) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Map")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.subdivision.map !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.subdivision.map) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tLEGAL DESCRIPTION\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("Description")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.legalDescription !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.parcel.legalDescription) +
                    "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [
        _vm._v("\n\t\t\tFIPS CODES\n\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("State")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.stateFIPS !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.parcel.stateFIPS) + "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _c("label", [_vm._v("County")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-value-right" }, [
          _vm.parcel.countyFIPS !== null
            ? _c("span", [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.parcel.countyFIPS) + "\n\t\t\t\t"
                )
              ])
            : _c("span", { staticClass: "undef" }, [
                _vm._v("\n\t\t\t\t\t-\n\t\t\t\t")
              ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "property-row" }, [
      _c(
        "small",
        { staticClass: "float-right text-muted font-weight-light mt-updated" },
        [
          _vm._v(
            "\n\t\t\tparcel updated " +
              _vm._s(_vm._f("ago")(_vm.parcel.updated)) +
              "\n\t\t\t"
          ),
          _c("i", { staticClass: "material-icons md-14" }, [
            _vm._v("query_builder")
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "sponsored-section" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "text-right" }, [
          _c("small", [
            _c(
              "a",
              {
                staticClass: "link-gray",
                attrs: { href: _vm.serviceProviderHref() }
              },
              [_vm._v("\n\t\t\t\t\t\tAre you a service provider?\n\t\t\t\t\t")]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lock-icon-box" }, [
      _c("i", { staticClass: "material-icons md-36" }, [_vm._v("lock")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category sponsored-category" }, [
      _c(
        "div",
        { staticClass: "font-weight-bold text-light-gray sponsored-head" },
        [_vm._v("\n\t\t\t\tPROFESSIONAL SERVICES\n\t\t\t")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "category sponsored-category" }, [
      _c("h4", { staticClass: "sponsored-title" }, [
        _vm._v("\n\t\t\t\tDevelopment feasibility\n\t\t\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _vm._v(
          "\n\t\t\t\tLooking to further understand the development potential for a property? Have an experienced architect review the municipal code and compile a feasibility study for you.\n\t\t\t"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row overflow-hidden mb-2" }, [
        _c(
          "a",
          {
            staticClass: "btn btn-sm btn-dark float-right",
            attrs: { href: "tel:+1-619-304-0300" }
          },
          [_vm._v("CALL 619-304-0300")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b94c972", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b94c972","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parcel/parcel-overview.vue
// module id = null
// module chunks = 